import * as React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"

const seo = {
    title: "Products: Vibra One phone booth and Vibra Four meeting pod",
    description: "The Vibra range: Vibra One, a one-person soundproof phone booth available now, and Vibra Four, a meeting pod for up to four people built to your requirements.",
}

const Products = ({ data }) => (
    <Layout seo={seo}>
        <div className="breadcrumb-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row breadcrumb_box  align-items-center">
                            <div className="col-lg-6 col-md-6 col-sm-6 text-center text-sm-left">
                                <h1 className="breadcrumb-title">Products</h1>
                            </div>
                            <div className="col-lg-6  col-md-6 col-sm-6">
                                <ul className="breadcrumb-list text-center text-sm-right">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active">Products</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="site-wrapper-reveal border-bottom">
            <div className="featuted-product-wrap section-space--pt_120">
                <div className="container">
                    <div className="row align-items-center featuted-product-one">
                        <div className="col-lg-6 col-md-6 order-lg-2 order-1">
                            <div className="product-thumbnail">
                                <Link to="/vibra-one/"><Img fluid={data.vibraOne.childImageSharp.fluid} alt="Vibra One phone booth"></Img></Link>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 order-lg-1 order-2">
                            <div className="featured-product-contect">
                                <h3 className="section-title"><Link to="/vibra-one/">Vibra One</Link></h3>
                                <h6 className="featured-pice">One-person soundproof booth · available now</h6>
                                <ul className="product-spec-list section-space--mt_30" style={{ color: '#666' }}>
                                    <li>Exterior H 2210 × W 1040 × D 940 mm, under one square metre of floor</li>
                                    <li>LED light 3000 K, quiet ventilation, motion-sensed power</li>
                                    <li>Laminated MDF, mineral wool and acoustic felt sandwich wall</li>
                                    <li>Freestanding, runs from a standard socket</li>
                                </ul>
                                <div className="button-box section-space--mt_40">
                                    <Link to="/vibra-one/" className="btn--text-icon">See Vibra One <i className="arrow_carrot-2right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--ptb_120">
                <div className="container">
                    <div className="row align-items-center featuted-product-one">
                        <div className="col-lg-6 col-md-6 order-lg-1 order-1">
                            <div className="product-thumbnail">
                                <Img fluid={data.vibraFour.childImageSharp.fluid} alt="Vibra Four meeting pod, made to order"></Img>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 order-lg-2 order-2">
                            <div className="featured-product-contect">
                                <h3 className="section-title">Vibra Four</h3>
                                <h6 className="featured-pice">Meeting pod for up to four people · built to your requirements</h6>
                                <p className="section-space--mt_30" style={{ color: '#666' }}>
                                    Vibra Four is a custom solution. It uses the same wall construction, light and ventilation as Vibra One, and we size and configure it for your space: footprint, seating, table, glazing, power and finishes are agreed with you before we build. Tell us about the room and how the team will use it, and we will come back with a proposal.
                                </p>
                                <div className="button-box section-space--mt_40">
                                    <Link to="/contact-us/" className="btn--text-icon">Tell us what you need <i className="arrow_carrot-2right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
)

export const query = graphql`
  query {
    vibraOne: file(relativePath: { eq: "home/vibra-one-banner-s.jpg" }){
        childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    vibraFour: file(relativePath: { eq: "home/vibra-four-banner-s.jpg" }){
        childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
  }`

export default Products
